import React from 'react'
import MenuItem from '../MenuItem'
import {Box} from '@mui/material'
import {toast} from 'sonner'
import {useTranslation} from 'react-i18next'
import {beforeCloseModalOrResetAlert} from 'services/alert'

const BeforeCloseMutationMenuItem = ({
    useMutation,
    itemId,
    handleClose,
    title,
    Icon,
    translationKey,
    confirmText,
    confirmButtonText,
    confirmTitle,
}) => {
    const [doMutation] = useMutation()
    const {t} = useTranslation()

    const onClickHandler = (e) => {
        e?.stopPropagation()
        handleClose?.(e)

        beforeCloseModalOrResetAlert({
            title: confirmTitle || t('modal.confirm_title'),
            text: confirmText || t(`${translationKey}.confirm`),
            confirmText: confirmButtonText || t('modal.confirm_action'),
            onConfirm: () =>
                toast.promise(
                    doMutation(itemId).unwrap(),
                    {
                        loading: t('loading'),
                        success: () => t(`${translationKey}.success`),
                        error: (err) => err?.data?.error || t(`${translationKey}.error`),
                    }
                ),
            t,
        })
    }

    return (
        <MenuItem key={`table_action_${itemId}`} onClick={onClickHandler}>
            <Box display={'flex'} justifyContent={'space-between'} width={'100%'}>
                <div>{t(`menuItem.${title}`)}</div>
                {Icon && <Icon />}
            </Box>
        </MenuItem>
    )
}

export default BeforeCloseMutationMenuItem
